import { Button, Drawer, Form, Input, Row, Select, notification } from 'antd'
import './DrawerDecision.style.less'
import { DoubleRightOutlined, EditOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'
import { saveDecisionRef } from '../../InSpectionReport.service'
import { useParams } from 'react-router-dom'
import { useMutation } from 'react-query'
import { queryClient } from '@/config/react-query'

interface Props {
  onClose: () => void
  open: boolean
  data: any
  index: number
}

function DrawerDecision(props: Props) {
  const onFinish = () => {}

  const [form] = Form.useForm()

  const param = useParams()
  const [isChange, setisChange] = useState(false)
  const [mouseOver, setMouseOver] = useState(false)

  useEffect(() => {
    if (!props.open) {
      setisChange(false)
    }
  }, [props.open])

  const Decisions = [
    'Shipment Release',
    'Short ship',
    'Release Under Guarantee',
    'Unauthorized Shipment',
  ]

  useEffect(() => {
    if (props.open) {
      form.setFieldsValue({
        decision: props.data?.decision,
        comment: props.data?.comment,
      })
    } else {
      form.resetFields()
    }
  }, [props.open])

  useEffect(() => {
    const isOpenSelect = document.querySelector('.ant-select-open')
    const allowScrolling = !mouseOver && !isOpenSelect
    if (allowScrolling) {
      document.body.style.overflow = 'auto'
    } else {
      document.body.style.overflow = ''
    }
  }, [mouseOver])

  const onSave: any = useMutation(async () => {
    await form.validateFields()
    const values = form.getFieldsValue()
    await saveDecisionRef(param?.key, values.decision, values.comment)
    await queryClient.invalidateQueries(['GET_REPORT_DATA_HEADER'])
    await queryClient.invalidateQueries(['GET_REPORT_DATA'])
    props.onClose()
    setisChange(false)
  })

  useEffect(() => {
    if (onSave.isError) {
      notification.error({
        message: onSave.error?.response?.data?.message,
        duration: 3,
        placement: 'top',
      })
    }
  }, [onSave.isError])
  return (
    <Drawer
      title=""
      placement={'right'}
      closable={false}
      open={props.open}
      key={'right'}
      width={400}
      onMouseOver={() => {
        setMouseOver(true)
      }}
      onMouseLeave={() => setMouseOver(false)}
    >
      <div className="drawer-decision-container">
        <Button
          onClick={props.onClose}
          className="button-close"
          icon={<DoubleRightOutlined className="close-icon" />}
        />
        <Row align={'middle'} className="title-container">
          <EditOutlined /> <p>Edit Decision</p>
        </Row>
        <p className="section-name">Decision</p>
        <Form
          form={form}
          onFinish={onFinish}
          autoComplete="off"
          onChange={() => {
            setisChange(true)
          }}
          layout="vertical"
          disabled={onSave.isLoading}
        >
          <Form.Item name={'decision'} label="Inspection Decision">
            <Select
              placeholder="Decision"
              allowClear
              onChange={() => {
                setisChange(true)
              }}
              style={{
                color: '#848484',
              }}
            >
              {Decisions.map((item) => {
                return (
                  <Select.Option
                    style={{
                      color: '#848484',
                    }}
                    key={item}
                    value={item}
                  >
                    {item}
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name={'comment'} label="Comment">
            <Input.TextArea autoSize size="large" placeholder="Comment" />
          </Form.Item>
        </Form>
        <Row className="button-container">
          <Button
            onClick={props.onClose}
            className="cancel"
            size="large"
            disabled={onSave.isLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={() => onSave.mutate()}
            size="large"
            type="primary"
            loading={onSave.isLoading}
            disabled={onSave.isLoading || !isChange}
          >
            Save
          </Button>
        </Row>
      </div>
    </Drawer>
  )
}

export default DrawerDecision
